import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { WfxFileUploadEntity } from "../dto/wfx-file.entity";


@Injectable()
export class WfxRepository extends Repository<WfxFileUploadEntity> {

    constructor(@InjectRepository(WfxFileUploadEntity) private WfxFileRepo: Repository<WfxFileUploadEntity>
    ) {
        super(WfxFileRepo.target, WfxFileRepo.manager, WfxFileRepo.queryRunner);
    }


    async getPDFInfo(req?:any): Promise<any[]> {
        const query = this.createQueryBuilder('co')
          .select(`*`);
        return await query.getRawMany();
      }
 




}